import { toast } from "react-semantic-toasts"

export const SuccessToast = (title, description) => {
    return toast({
        type: 'success',
        icon: 'thumbs up outline',
        title: title,
        description: description,
        animation: 'jiggle',
        time: 1000
    })
}

export const ErrorToast = (err) => {
    try {
        if (typeof err === 'string') {
            return toast({
                type: 'error',
                icon: 'exclamation',
                title: 'Error',
                description: err,
                animation: 'bounce',
                time: 5000
            });
        } else {
            let errorDetail = err.response?.data?.detail || "An unexpected error occurred."
            const status = err.response?.status || ''
            if(Array.isArray(errorDetail)){
                errorDetail = errorDetail[0].msg
            }
            return toast({
                type: 'error',
                icon: 'exclamation',
                title: `Error${status ? ` - ${status}` : ''}`,
                description: errorDetail,
                animation: 'bounce',
                time: 5000
            });
        }
    } catch {
        return toast({
            type: 'error',
            icon: 'exclamation',
            title: 'Error - Something went wrong',
            description: "An unexpected error occurred.",
            animation: 'bounce',
            time: 5000
        });
    }
}


export const WarningToast = (title, description) => {
    return toast({
        type: "warning",
        icon: "info circle",
        title: title,
        description: description,
        animation: 'tada',
        time: 8000
    })
}

export const InfoToast = (title, description) => {
    return toast({
        type: "info",
        icon: "info circle",
        title: title,
        description: description,
        animation: 'tada',
        time: 5000
    })
}